export default __webpack_public_path__ + "static/media/golf.1cef4064.png";